import { Component, OnInit } from "@angular/core";
import { BwletinService } from "src/app/craidd/gwasanaethau/bwletin/bwletin.service";
import { IBwletin } from "src/app/craidd/modelau/bwletin/bwletin";

@Component({
  selector: "app-bwletin-newydd",
  templateUrl: "./bwletin-newydd.component.html",
  styleUrls: ["./bwletin-newydd.component.scss"],
})
export class BwletinNewyddComponent implements OnInit {
  niferHebAgor: number;

  constructor(private bwletinService: BwletinService) {}

  ngOnInit(): void {
    this.nolNiferHebAgor();
  }

  nolNiferHebAgor(): void {
    this.bwletinService.niferHebAgor().subscribe({
      next: (data) => {
        let bwletin = data as IBwletin;
        this.niferHebAgor = bwletin.niferHebWediAgor;
      },
      complete: () => {},
    });
  }
}
